import { useDispatch } from "../../services/hooks";
import { login } from "../../services/login/actions";
import React from "react";
import { ENDPOINTS } from "../../config/api";
import styles from "./login.module.css";

export function Login(): JSX.Element {
  const dispatch = useDispatch();

  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");

  const handleLogin = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();

    dispatch(
      login(email, password)
    );
  };

  const handleLoginGoogle = (): void => {
    window.location.href = ENDPOINTS.LOGIN_GOOGLE;
  };

  return (
    <div className={styles.page}>
      <section className={styles.card} aria-label="login">
        <div className={styles.header}>

          <div className={styles.titleRow}>
            <h1 className={styles.title}>Login</h1>
          </div>
        </div>

        <form className={styles.form} id="login-form" noValidate onSubmit={handleLogin}>
          <label className={styles.label}>
            <span className={styles.labelText}>email</span>
            <input
              className={styles.input}
              type="email"
              value={email}
              name="email"
              placeholder="you@domain.com"
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
            />
          </label>

          <label className={styles.label}>
            <span className={styles.labelText}>password</span>
            <input
              className={styles.input}
              type="password"
              value={password}
              name="password"
              placeholder="••••••••"
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </label>

          <div className={styles.actions}>
            <button className={styles.primary} type="submit">
              Login
            </button>

            <button
              type="button"
              className={styles.google}
              onClick={handleLoginGoogle}
            >
              <span className={styles.googleIcon} aria-hidden="true">
                {/* Official multi-color Google G (simplified SVG) */}
                <svg viewBox="0 0 48 48" width="18" height="18">
                  <path fill="#EA4335" d="M24 9.5c3.54 0 6.72 1.22 9.22 3.61l6.85-6.85C35.9 2.3 30.34 0 24 0 14.64 0 6.64 5.64 2.88 13.7l7.98 6.2C12.8 13.22 17.94 9.5 24 9.5z" />
                  <path fill="#4285F4" d="M46.5 24.5c0-1.63-.15-3.2-.42-4.7H24v9h12.7c-.55 2.96-2.2 5.47-4.7 7.16l7.3 5.66C43.9 37.6 46.5 31.6 46.5 24.5z" />
                  <path fill="#FBBC05" d="M10.86 28.9a14.48 14.48 0 010-9.8l-7.98-6.2A24.01 24.01 0 000 24c0 3.88.93 7.54 2.88 10.9l7.98-6z" />
                  <path fill="#34A853" d="M24 48c6.34 0 11.9-2.1 15.86-5.7l-7.3-5.66c-2.02 1.36-4.6 2.16-8.56 2.16-6.06 0-11.2-3.72-13.14-9.4l-7.98 6.2C6.64 42.36 14.64 48 24 48z" />
                </svg>
              </span>

              <span>Login with Google</span>
            </button>

          </div>
        </form>
      </section>
    </div>
  );

}
